import { useEffect, useState } from "react";
import moment from "moment";
import { ApiCall } from "../../../helper/axios";

export const useCancellationPolicy = ({
  vendor,
  excursionId,
  contractId,
  tourOptionId,
  travelDate,
  startTime,
  commonId,
  enabled = true,
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;

    const fetchPolicy = async () => {
      if (!enabled || !excursionId || !travelDate) {
        return;
      }
      setLoading(true);
      setError("");
      try {
        const details = await ApiCall(
          "POST",
          `/excursions/cancellation-policy`,
          {
            vendor: vendor ?? "",
            excursionId: String(excursionId),
            contractId: contractId ? String(contractId) : "",
            tourOptionId: tourOptionId ? String(tourOptionId) : "",
            travelDate: moment(travelDate).format("YYYY-MM-DD"),
            startTime: startTime ?? "",
            currentDate: moment().format("YYYY-MM-DD"),
            ...(commonId ? { commonId } : {}),
          },
          {}
        );
        if (!mounted) return;
        const body = details?.data;
        const isError =
          body?.status === "error" ||
          (body?.statusCode && body?.statusCode >= 400) ||
          (details?.status && details?.status >= 400);
        if (isError) {
          setError(body?.message ?? "Unable to load cancellation policy.");
          setData(null);
          return;
        }
        setData(body?.statusCode && body?.data ? body.data : body);
      } catch (e) {
        if (mounted) {
          setError(e?.message ?? "Unable to load cancellation policy.");
          setData(null);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchPolicy();
    return () => {
      mounted = false;
    };
  }, [vendor, excursionId, contractId, tourOptionId, travelDate, startTime, commonId, enabled]);

  return { data, loading, error };
};
